import { lazy } from 'react';

// After a deploy, a tab that was already open still asks for the previous
// build's chunk filenames, which no longer exist -- the dynamic import
// rejects and React unmounts the whole app. Reloading once picks up the new
// build; if that doesn't fix it within the window, the real error surfaces
// instead of a reload loop. No sessionStorage (private mode, blocked site
// data) also means no reload, since a loop couldn't be prevented.
const RELOAD_FLAG = 'cbat_chunk_reload_at';
const RELOAD_WINDOW_MS = 10000;

const reloadedRecently = () => {
  try {
    return Date.now() - (Number(window.sessionStorage.getItem(RELOAD_FLAG)) || 0) < RELOAD_WINDOW_MS;
  } catch (error) {
    return true;
  }
};

const markReload = () => {
  try {
    window.sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
    return true;
  } catch (error) {
    return false;
  }
};

export const importWithReload = (importer) => importer().catch((error) => {
  if (!reloadedRecently() && markReload()) {
    window.location.reload();
    return new Promise(() => {});
  }
  throw error;
});

export const lazyWithReload = (importer) => lazy(() => importWithReload(importer));

// React.lazy needs a default export; this adapts one named export.
export const lazyNamedWithReload = (importer, exportName) => lazy(() => (
  importWithReload(importer).then((module) => ({ default: module[exportName] }))
));
